export default "__VITE_ASSET__BXGxfjUO__"